export function isCollectionNoticeRow(row) {
  return (
    row?.IsCollectionNoticeRow === true ||
    row?.IsInsertedInCurrentVisitNoticeRow === true ||
    row?.IsPendingInitialValuesNoticeRow === true
  );
}

export function isInsertedInCurrentVisitNoticeRow(row) {
  return isCollectionNoticeRow(row);
}

export function isPendingInitialValuesNoticeMachine(machine) {
  const typeName = machine?.MachineType?.Type || machine?.MachineType || null;
  return typeName === "Tragamoneda" && machine?.HasValidInitialValues === false;
}

export function isInsertedInCurrentVisitNoticeMachine(machine) {
  const typeName = machine?.MachineType?.Type || machine?.MachineType || null;
  return (
    isCollectionNoticeRow(machine) ||
    (typeName === "Tragamoneda" &&
      machine?.HasValidInitialValues === true &&
      machine?.ShowInsertedInCurrentVisitNotice === true &&
      machine?.IsCollectibleInCurrentVisit === false)
  );
}

export function isPersistedCollectedMachine(machine) {
  return !isCollectionNoticeRow(machine) && machine?.WasCollected !== false;
}

export function isVisitMachineCollected(machine, options = {}) {
  const { wasCollectedByLM, keyId, computeKey } = options;

  const resolvedKey =
    keyId ??
    (typeof computeKey === "function"
      ? computeKey(machine)
      : Number(machine?.LocalMachineId ?? machine?.Id ?? 0));

  if (
    wasCollectedByLM &&
    Number.isFinite(Number(resolvedKey)) &&
    typeof wasCollectedByLM[resolvedKey] === "boolean"
  ) {
    return wasCollectedByLM[resolvedKey];
  }

  if (typeof machine?.WasCollected === "boolean") {
    return machine.WasCollected;
  }

  return !isCollectionNoticeRow(machine);
}
